import { render, staticRenderFns } from "./addEditClaimsDocsModal.vue?vue&type=template&id=37254df2&"
import script from "./addEditClaimsDocsModal.vue?vue&type=script&lang=js&"
export * from "./addEditClaimsDocsModal.vue?vue&type=script&lang=js&"
import style0 from "./addEditClaimsDocsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports